// Sdílená instance QueryClient — importuj ji místo vytváření nové instance.
// Díky tomu ji lze volat i mimo React strom (např. z Zustand store).
import { QueryClient } from '@tanstack/react-query'

// Chyby, u kterých je opakování zbytečné — odpověď se podruhé nezmění.
// 401/403 (nepřihlášen / bez práva), 404 (není), 400/422 (špatný dotaz).
const NO_RETRY_STATUS = new Set([400, 401, 403, 404, 422])

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Jedno opakování jako záchrana proti výpadku sítě / dočasné chybě serveru.
      // Víc ne — dotazy, které v jednom queryFn stahují desítky až stovky řad, by
      // každým opakováním poslaly celou vlnu requestů znovu.
      retry: (failureCount, error) => {
        if (NO_RETRY_STATUS.has(error?.status)) return false
        return failureCount < 1
      },
      retryDelay: 1000,
    },
  },
})
